"use client";

import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { IoCloseSharp } from "react-icons/io5";
import { LuSearch } from "react-icons/lu";

export default function SearchModal({ onClose }: { onClose: any }) {
	const [searchQuery, setSearchQuery] = useState("");
	const inputRef = useRef<HTMLInputElement>(null);
	const modalRef = useRef<HTMLDivElement>(null);
	const contentRef = useRef<HTMLDivElement>(null);
	const router = useRouter();

	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.focus();
		}
	}, []);

	useEffect(() => {
		const handleKey = (e: KeyboardEvent) => {
			if (e.key === "Escape") {
				e.preventDefault();
				onClose();
				return;
			}
			if (e.key === "Enter" && searchQuery.trim()) {
				router.push("/search/" + encodeURIComponent(searchQuery.trim()));
				onClose();
			}
		};

		const handleClickOutside = (e: MouseEvent) => {
			if (
				contentRef.current &&
				!contentRef.current.contains(e.target as Node)
			) {
				onClose();
			}
		};

		document.addEventListener("keydown", handleKey);
		document.addEventListener("mousedown", handleClickOutside);

		document.body.style.overflow = "hidden";
		document.body.style.position = "fixed";
		document.body.style.width = "100%";
		document.body.style.height = "100%";

		return () => {
			document.removeEventListener("keydown", handleKey);
			document.removeEventListener("mousedown", handleClickOutside);

			document.body.style.overflow = "auto";
			document.body.style.position = "static";
			document.body.style.width = "auto";
			document.body.style.height = "auto";
		};
	}, [onClose, searchQuery, router]);

	return createPortal(
		<div
			ref={modalRef}
			className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-[9999]"
			onClick={(e) => {
				if (e.target === e.currentTarget) {
					onClose();
				}
			}}
		>
			<div ref={contentRef} className="w-full max-w-4xl px-2">
				<button
					type="button"
					className="absolute top-5 right-5 text-white text-3xl hover:text-gray-300 transition-colors"
					onClick={onClose}
					aria-label="بستن جستجو"
				>
					<IoCloseSharp className="w-6 h-6" />
				</button>

				<div className="w-full">
					<div className="relative">
						<input
							ref={inputRef}
							type="text"
							value={searchQuery}
							onChange={(e) => setSearchQuery(e.target.value)}
							placeholder="جستجو کنید..."
							className="w-full bg-transparent text-white text-3xl md:text-5xl lg:text-6xl placeholder:text-gray-500 placeholder:text-2xl md:placeholder:text-3xl lg:placeholder:text-4xl border-0 border-b-2 border-gray-700 focus:border-light-lime focus:ring-0 outline-none py-6 pl-16 pr-4 transition-colors duration-300"
							dir="rtl"
							autoComplete="off"
							autoFocus
						/>
						<Link
							href={`/search/${searchQuery}`}
							className="absolute left-2 top-1/2 transform -translate-y-1/2 p-3 text-gray-400 hover:text-white transition-colors"
							aria-label="ارسال جستجو"
							onClick={() => onClose()}
						>
							<LuSearch className="w-8 h-8 md:w-10 md:h-10" />
						</Link>
					</div>
				</div>
			</div>
		</div>,
		document.body,
	);
}
